import { Reveal } from "./Reveal";
import { keyNumbers } from "@/data/numbers";

export const StatBar = () => (
  <section className="bg-linen border-y hairline" data-testid="stat-bar">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
      <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-ink/10">
        {keyNumbers.map((n, i) => (
          <Reveal key={n.label} delay={i * 0.06}>
            <div className="py-8 md:py-12 md:px-8 first:md:pl-0" data-testid={`stat-${i + 1}`}>
              <p className="font-display font-light text-4xl sm:text-5xl text-ink leading-none">{n.value}</p>
              <p className="mt-3 font-sans-ui text-[11px] tracking-mega text-ink/55">{n.label.toUpperCase()}</p>
              {n.sub && <p className="mt-1 font-sans-ui text-[12px] text-ink/45">{n.sub}</p>}
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
